import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { getCookie, getQuery } from 'sutils';
import { DRIVE_ENV } from './drive-env';

/**
 * 环境 ID
 * - B: free_go_proxy: e.g. sit-online995 , auto-enterprise
 * - C: env_id: e.g. sit-8ba33295
 *
 * NOTE: C 端有 staging/canary 作为灰度环境， 而 B 端当前没有，只有 正式/测试
 */
function getEnvId(): string {
    const envId: string | null = __IS_WECOM__ ? getCookie('free_go_proxy') : getCookie('env_id');
    return envId || '';
}

/**
 * 环境 NAME
 * - C: env_name: e.g. feature/xxx_88888888
 *
 * NOTE: C 端环境 ID 的可读化表示，可以不存在。而 B 端用 ID 表示 NAME 足矣
 */
function getEnvName(): string {
    const envName: string | null = __IS_WECOM__ ? getCookie('free_go_proxy') : getCookie('env_name');
    return envName || '';
}

/** 测试环境标识: **production 构建** 且 **带有测试环境ENV_ID** */
function isTestEnv(): boolean {
    if (process.env.NODE_ENV === 'development') return false;

    const envId = getEnvId();
    if (__IS_WECOM__) return !!envId;

    return envId === 'uat' || envId.startsWith('sit');
}

/** 正式环境标识: **production 构建** 且 **非测试环境** */
function isReleaseEnv(): boolean {
    return __IS_PROD__ && !isTestEnv();
}

/** PC客户端本地编辑环境标识 */
function isPcLocalEdit(): boolean {
    return !!(getQuery('local_edit') && browser.isTencentDocDesktopApp);
}

/** 移动端APP本地编辑环境标识 */
function isMobileAppLocalEdit(): boolean {
    return !!(getQuery('local_edit') && (browser.isTencentDocApp || browser.isMobileQQApp));
}

/**
 * 子窗口标识
 * 场景: 备注视图
 */
function isSubsidiary() {
    // TODO: query 不太安全, 改为父窗口注入全局标识
    return getQuery('isSubsidiary') === '1';
}

/**
 * 是否是文库跳转而来
 * @returns
 */
function isWenku() {
    return getQuery('source') === 'wenku';
}

export const testable = {
    getEnvId,
    isTestEnv,
    isReleaseEnv,
};

const ENV = {
    /** ENV_ID 注意是页面初始化时计算的常量，不受代码逻辑变更 cookie 影响 */
    ENV_ID: getEnvId(),
    /** ENV_NAME 也是页面初始化时计算的常量，只是 ENV_ID 的可读化展示，可以不存在 */
    ENV_NAME: getEnvName(),
    /** 测试环境标识 */
    IS_TEST: isTestEnv(),
    /** 正式环境标识 */
    IS_RELEASE: isReleaseEnv(),
    /** 桌面端本地编辑 */
    IS_PC_LOCAL_EDIT: isPcLocalEdit(),
    /** 移动端本地编辑 */
    IS_MOBILE_LOCAL_EDIT: isMobileAppLocalEdit(),
    /** 本地编辑 */
    IS_LOCAL_EDIT: isPcLocalEdit() || isMobileAppLocalEdit(),
    /** 子窗口标识 **/
    IS_SUBSIDIARY: isSubsidiary(),
    /** 是否是文库跳转而来 */
    IS_WENKU: isWenku(),
    /** 云文档环境入口 **/
    DRIVE_ENV,
};

export default ENV;
